export const LOADING_STATUS = {
    initial: "initial",
    loading: "loading",
    loaded: "loaded",
    error: "error",
}